import { apiServer } from '../utils/variables';

export const gameTime2Minutes = (gameTime) => {
  const minutes = Math.floor(gameTime * (1 / 60));
  let seconds = (gameTime % 60);
  seconds = `${seconds < 10 ? `0${seconds || '0'}` : seconds}`;
  return `${minutes < 10 ? `0${minutes || '0'}` : minutes}:${seconds}`;
};

export const headline = text => text ? `<div class="headline">${text}</div>` : '';

export const subheadline = text => text ? `<div class="subheadline">${text}</div>` : '';

export const comment = text => text ? `<div class="comment">${text}</div>` : '';

export const image = src => src ? `<div class="image" style="background-image:url(${apiServer}${src})"></div>` : '';

export const gameTimeEl = (gameTime) => `
  <div class="gametime">
    <div>
      <span>
        ${gameTime2Minutes(gameTime)}
      </span>
    </div>
  </div>
`;

const berlinIsHome = game => game.home_away === 'Home';

const isForBerlin = item => !item.playerName;

const scoreFor = (item, game) => {
  const forBerlin = isForBerlin(item);
  const isHome = berlinIsHome(game);
  if ((forBerlin && isHome) || (!forBerlin && !isHome)) return 'home';
  if ((forBerlin && !isHome) || (!forBerlin && isHome)) return 'visitor';
};

const teamInfo = (game, forBerlin) => {
  const isHome = berlinIsHome(game);
  if (forBerlin) return game[isHome ? 'home' : 'visitor'];
  return game[!isHome ? 'home' : 'visitor'];
}

export const penaltyTeamImage = (item, game) => {
  if (!game) return '';
  const { logo } = teamInfo(game, !item.playerName);
  return `${apiServer}${logo}`;
};

const berlinPlayer = player => `<div class="player berlin">
  <div class="portrait" style="background-image:url(${apiServer}${player.image})"></div>

  <div class="name">
    <div class="first">${player.firstname}</div>

    <div class="last">${player.lastname}</div>
  </div>

  <div class="number">${player.number}</div>
</div>`;

const opponentPlayer = (name, number) => `
<div class="player opponent">
  <div class="name">${name}</div>

  <div class="number">${number}</div>
</div>
`;

const playerById = (players, id) => (players.find(player => ''+player.id === ''+id) || {});

export default {
  goal: (item, game, players) => {
    const scorer = scoreFor(item, game);
    const isHome = berlinIsHome(game);
    const homeGoals = isHome ? item.goals.berlin : item.goals.opponent;
    const visitorGoals = !isHome ? item.goals.berlin : item.goals.opponent;

    let playerInfo = '';
    if (item.playerId) {
      playerInfo = berlinPlayer(playerById(players, item.playerId));
    } else {
      playerInfo = opponentPlayer(item.playerName, item.playerNumber);
    }

    return `
      ${gameTimeEl(item.gameTime)}
      <div class="meta">
        <div class="team${scorer === 'home' ? ' scorer' : ''} home">
          <div class="logo home" style="background-image: url(${apiServer}${game.home.logo})"></div>
        </div>

        <div class="display colossalis">
          <div class="score${scorer === 'home' ? ' scorer' : ''} home">${homeGoals}</div>
          <div class="score splitter">:</div>
          <div class="score${scorer === 'visitor' ? ' scorer' : ''} visitor">${visitorGoals}</div>
        </div>

        <div class="team${scorer === 'visitor' ? ' scorer' : ''} vistor">
          <div class="logo vistor" style="background-image: url(${apiServer}${game.visitor.logo})"></div>
        </div>
      </div>
      ${headline(item.headline)}
      ${playerInfo}
      ${subheadline(item.subHeadline)}
      ${comment(item.comment)}
      ${image(item.image)}
    `;
  },
  penalty: (item, game, players) => {
    let { playerName } = item;
    if (!playerName) {
      const player = players.find(player => `${player.id}` === `${item.playerId}`);
      playerName = player ? `${player.lastname}, ${player.firstname}` : '';
    }
    return `
      ${gameTimeEl(item.gameTime)}
      <div class="meta">
        <div class="logo" style="background-image: url(${penaltyTeamImage(item, game)});"></div>
        <div class="texts">
          ${headline(`Strafe: ${playerName}`)}
          ${subheadline(item.subHeadline)}
        </div>
        <div class="icon"></div>
      </div>
      ${comment(item.comment)}
      ${image(item.image)}
    `;
  },
  penaltyend: (item, game) => `
    ${gameTimeEl(item.gameTime)}
    <div class="meta">
      <div class="texts">
        ${headline('Strafe abgelaufen')}
      </div>
      <div class="icon"></div>
    </div>
    ${comment(item.comment)}
    ${image(item.image)}
  `,
  warmup: (item, game) => `
    ${gameTimeEl(item.gameTime)}
    ${headline(item.headline)}
    ${subheadline(item.subHeadline)}
    ${comment(item.comment)}
    ${image(item.image)}
  `,
  periodstart: (item, game) => `
    ${gameTimeEl(item.gameTime)}
    <div class="period-label">Start</div>
    <h1>${item.periodName}</h1>
    ${headline(item.headline)}
    ${subheadline(item.subHeadline)}
    ${comment(item.comment)}
    ${image(item.image)}
  `,
  periodend: (item, game) => `
    ${gameTimeEl(item.gameTime)}
    <div class="period-label">Ende</div>
    <h1>${item.periodName}</h1>
    ${headline(item.headline)}
    ${subheadline(item.subHeadline)}
    ${comment(item.comment)}
    ${image(item.image)}
  `,
  comment: (item, game) => `
    ${gameTimeEl(item.gameTime)}
    ${headline(item.headline)}
    ${subheadline(item.subHeadline)}
    ${comment(item.comment)}
    ${image(item.image)}
  `,
};



// WEBPACK FOOTER //
// ./src/browser/liveticker.events.js